import { type ModelTimestamp } from "@doitintl/models-any";
import { Divider } from "@mui/material";

import { getDatetimeAndDiffFromTimestamp } from "../../../../../utils/time";

interface StatusTooltipContentProps {
  updatedTimestamp?: ModelTimestamp;
  body?: React.ReactNode;
}

const StatusTooltipContent = ({ updatedTimestamp, body }: StatusTooltipContentProps) => {
  const { exactDatetime, timeAgo } = getDatetimeAndDiffFromTimestamp(updatedTimestamp);

  const timeSection = (
    <>
      <p>Last updated {timeAgo}</p>
      <p>({exactDatetime})</p>
    </>
  );

  return (
    <>
      {timeSection}
      {!!body && (
        <>
          <Divider />
          {body}
        </>
      )}
    </>
  );
};

export default StatusTooltipContent;
